import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from 'vue';

interface DirectionsResponse {
  routes?: any[];
  status: string;
  request?: {
    origin?: {
      query?: string;
    };
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DistanceToOffice',
  props: {
  address: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['office-selected'],
  setup(__props, { emit }) {

const props = __props





const officeAddresses = ['2406 W. 11th St., Pueblo Co 81003', '2130 Academy Cir, #B, Colorado Springs 80909'];

const results = ref<DirectionsResponse[]>([]);
const isLoading = ref(true);
const hasError = ref(false);
const selectedOfficeIndex = ref<number | null>(null);

// eslint-disable-next-line no-undef
const directionsService = new google.maps.DirectionsService();

function selectOffice(index: number) {
  if (props.disabled) return;
  selectedOfficeIndex.value = index;
  emitSelection();
}

function emitSelection() {
  if (selectedOfficeIndex.value === null) return;
  const result = results.value[selectedOfficeIndex.value];
  const durationSeconds = result?.routes?.[0]?.legs?.[0]?.duration?.value ?? 0;
  emit('office-selected', {
    address: result?.request?.origin?.query ?? '',
    travelTimeMinutes: Math.round(durationSeconds / 60),
  });
}

watch(
  () => props.address,
  async () => {
    try {
      isLoading.value = true;
      const promises = officeAddresses.map(async officeAddress => {
        try {
          return await getRoute(officeAddress, props.address);
        } catch (error) {
          console.error('Error fetching route:', error);
          throw error;
        }
      });

      results.value = await Promise.all(promises);
      // Re-emit if an office was already selected and address changed
      if (selectedOfficeIndex.value !== null) {
        emitSelection();
      }
    } catch (error) {
      console.error('Error fetching directions:', error);
      hasError.value = true;
    } finally {
      isLoading.value = false;
    }
  },
  { immediate: true }
);

function getRoute(
  origin: string,
  destination: string,
  travelMode: 'DRIVING' | 'WALKING' | 'BICYCLING' | 'TRANSIT' = 'DRIVING'
) {
  return new Promise<DirectionsResponse>((resolve, reject) => {
    const route = {
      origin,
      destination,
      travelMode,
    };

    directionsService.route(route, (result: DirectionsResponse, status: string) => {
      if (status === 'OK') {
        resolve(result);
      } else {
        reject(new Error(`Google Maps API error: ${status}`));
      }
    });
  });
}

return { __sfc: true,props, emit, officeAddresses, results, isLoading, hasError, selectedOfficeIndex, directionsService, selectOffice, emitSelection, getRoute }
}

})